"use client";

import { useEffect, useState } from "react";
import { useUser } from "@clerk/nextjs";
import toast from "react-hot-toast";
import { useEffectivePass } from "@/hooks/useEffectivePass";
import TrialActivatedModal from "@/components/TrialActivatedModal";

export default function TrialBanner() {
  const { isTrial, isTrialExpired, freeTrialExpiresAt, isLoaded, isSignedIn, passType } = useEffectivePass();
  const { user } = useUser();
  const [showTrialModal, setShowTrialModal] = useState(false);

  const hasPdfPurchase = user?.publicMetadata?.hasPdfPurchase === true;

  // 체험 모달 1회 표시 — 외부 localStorage/sessionStorage 동기화
  useEffect(() => {
    if (!isLoaded || !isSignedIn) return;

    if (isTrial && freeTrialExpiresAt) {
      // 체험 활성: 최초 1회만 모달 표시
      const alreadyShown = localStorage.getItem("trialToastShown");
      if (alreadyShown) return;

      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowTrialModal(true);
      localStorage.setItem("trialToastShown", "true");
    } else if (isTrialExpired && passType === "free" && !hasPdfPurchase) {
      // 체험 만료 + PDF 미구매: 세션당 1회 토스트 표시
      const sessionShown = sessionStorage.getItem("trialExpiredToastShown");
      if (sessionShown) return;

      toast("무료 체험이 만료되었습니다. 이용권을 구매해 주세요.", {
        icon: "⏰",
        duration: 5000,
      });
      sessionStorage.setItem("trialExpiredToastShown", "true");
    }
  }, [isLoaded, isSignedIn, isTrial, isTrialExpired, freeTrialExpiresAt, passType, hasPdfPurchase]);

  return (
    <TrialActivatedModal
      isOpen={showTrialModal}
      onClose={() => setShowTrialModal(false)}
      freeTrialExpiresAt={freeTrialExpiresAt}
    />
  );
}
